import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="add-tests-to-step"
export default class extends Controller {
  static values = {
    isGenericTests: Boolean,
    texts: Object,
  };

  connect() {
    this.elems = [];
    const initialTests = JSON.parse(this.element.dataset.initialTests);

    document.addEventListener(
      "turbo:frame-load",
      this.handleFrameLoad.bind(this)
    );

    initialTests.forEach((test) => {
      this._addTestToList(test.id, test.name);
      this._toogleButton(
        document.querySelector(`a[data-test-id="${test.id}"]`)
      );
      this._updateHiddenInput();
    });
  }

  handleFrameLoad(event) {
    const frame = event.target;

    if (frame.contains(this.element.querySelector("#tests-card-list"))) {
      const buttons = frame.querySelectorAll("a.btn-add-test");
      buttons.forEach((button) => {
        const testId = button.dataset.testId;
        const existingTest = this.elems.find((elem) => elem.id === testId);

        if (existingTest) {
          button.classList.add("btn-danger");
          button.classList.remove("btn-outline-primary");
          button.innerHTML =
            this.textsValue?.["remove_test"] ||
            JSON.parse(this.element.dataset.texts)?.["remove_test"];
        } else {
          button.classList.add("btn-outline-primary");
          button.classList.remove("btn-danger");
          button.innerHTML =
            this.textsValue?.["add_test"] ||
            JSON.parse(this.element.dataset.texts)?.["add_test"];
        }
      });

      this._updateHiddenInput();
    }
  }

  toggleItem(event) {
    event.preventDefault();

    const testId = event.currentTarget.dataset.testId;
    const testName = event.currentTarget.dataset.testName;
    const button = document.querySelector(`a[data-test-id="${testId}"]`);

    this._addTestToList(testId, testName);
    this._remove_pill(testId);
    this._toogleButton(button);
    this._updateHiddenInput();
  }

  _remove_pill(testId) {
    const pill = document.querySelector(`div[data-test-id="${testId}"]`);

    if (pill) {
      pill.remove();
    }
  }

  _toogleButton(button) {
    button.classList.toggle("btn-outline-primary");
    button.classList.toggle("btn-danger");

    if (button.classList.contains("btn-danger")) {
      button.innerHTML =
        this.textsValue?.["remove_test"] ||
        JSON.parse(this.element.dataset.texts)?.["remove_test"];
    } else {
      button.innerHTML =
        this.textsValue?.["add_test"] ||
        JSON.parse(this.element.dataset.texts)?.["add_test"];
    }
  }

  _addTestToList(testId, testName) {
    const existingTest = this.elems.find((elem) => elem.id === testId);

    if (existingTest) {
      this.elems = this.elems.filter((elem) => elem.id !== testId);
    } else {
      this.elems.push({ id: testId, name: testName });
    }
  }

  _updateHiddenInput() {
    const inputName = this.isGenericTestsValue
      ? "ats_step[generic_tests][]"
      : "ats_step[test_ids][]";
    const hiddenInputs = document.getElementById("hiddenInputs");
    hiddenInputs.innerHTML = "";

    this.elems.forEach((elem) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = inputName;
      input.value = elem.id;
      hiddenInputs.appendChild(input);
    });

    if (this.elems.length === 0) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = inputName;
      input.value = "";
      hiddenInputs.appendChild(input);
    }
  }
}
